import React from "react"
import { Form, Input, FormGroup } from "reactstrap"
import validateInput from "../../view/shared/validations/login"
import { Trans, useLingui } from "@lingui/react"
import "react-phone-number-input/style.css"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import ar from "react-phone-input-2/lang/ar.json"
import { connect } from "react-redux"
import { selectCreatedVslaInfo } from "../../store/reducers/getVslas"
import { loginAction, logoutAction, trackActivity } from "../../store/actions/auth"
import { t } from "@lingui/macro"
import { triggerAction } from "../../store/constants"
import { arabicToInt } from "../../view/shared/utilities/arabicNumParser"
import { precacheData } from "../../store/actions/precache"
import { setCurrentPage } from "../../store/reducers/navigation"
import PropTypes from "prop-types"

const headerStyle = {
  color: "#E36F1E",
  fontFamily: "quicksand",
  fontWeight: "bolder",
  fontSize: "1.8em",
  textAlign: "center",
  paddingBottom: "0.5em",
}

const formStyle = {
  flex: "10",
  padding: "5px",
  fontFamily: "Fira Sans",
  fontSize: "20px",
  height: "50px",
  width: "100%",
}

const LoginForm = (props) => {
  const { i18n } = useLingui()
  // eslint-disable-next-line
  const [state, setState] = React.useState({
    phone_number: "",
    password: "",
    errors: {},
    bounce: "",
    isLoaded: false,
    lang: i18n.locale,
    buttonDisable: false,
  })
  const [bounce, setBounce] = React.useState("")
  const [_country] = React.useState(localStorage.getItem("_country") || "GH")

  const onChange = (e) => {
    const { name, value } = e.target
    if (name === "password" && isNaN(value)) {
      return
    }
    setState({ ...state, buttonDisable: false })
    setState({ ...state, [name]: value })
  }

  const isValid = () => {
    const { errors, isValid } = validateInput(state)

    if (!isValid) {
      setState({ ...state, errors })
      return isValid
    }

    return isValid
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    if (isValid()) {
      setState({ ...state, buttonDisable: true, bounce: "" })
      try {
        await props.login(state.phone_number, arabicToInt(state.password))
        setState({ phone_number: "", password: "" })
      } catch (error) {
        setState({
          ...state,
          buttonDisable: false,
        })
        setBounce(error === "Incorrect username or password"
          ? t({ id: "Incorrect username or password" })
          : error)
      }
    }
  }

  return (
    <div>
      <div>
        {["uat", "staging"].includes(
          window.REACT_APP_PWA_APP_ENV.toLocaleLowerCase().toLocaleLowerCase(),
        ) && (
            <p style={{ textAlign: "center", fontWeight: "700", padding: 12 }}>
              <Trans
                id={`${window.REACT_APP_PWA_APP_ENV.toLocaleLowerCase().toLocaleLowerCase()} version`}
              />
            </p>
          )}
        <h4 style={headerStyle}>
          <Trans id="login" />
        </h4>
      </div>
      {bounce && <div className="alert alert-danger">{bounce}</div>}
      <Form onSubmit={onSubmit}>
        <FormGroup
          style={{
            direction: "ltr",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {state.errors && (
            <span name="phone_validation" style={{ color: "red" }}>
              {state.errors.phone_number}
            </span>
          )}
          <PhoneInput
            name="phone_number"
            country={_country.toLocaleLowerCase()}
            enableSearch
            disableSearchIcon
            placeholder={t({ id: "Phone number" })}
            error={state.errors ? state.errors.phone_number : ""}
            inputStyle={{
              flex: "10",
              fontFamily: "Fira Sans",
              height: "50px",
              width: "100%",
              fontSize: "20px",
            }}
            style={{ ...loadingStyle, alignSelf: "end" }}
            value={state.phone_number}
            onChange={(phone_number) => setState({ ...state, phone_number })}
            limitMaxLength={true}
            localization={i18n.locale === "ar" ? ar : false}
          />
        </FormGroup>

        <FormGroup>
          {state.errors && (
            <span name="pin_validation" style={{ color: "red" }}>
              {state.errors.password}
            </span>
          )}
          <Input
            type="password"
            name="password"
            style={formStyle}
            placeholder={t({ id: "PIN" })}
            onChange={onChange}
            error={state.errors ? state.errors.password : ""}
            value={state.password}
          />
        </FormGroup>
        <FormGroup>
          <button
            value={
              state.buttonDisable
                ? t({ id: "Submitting..." })
                : t({ id: "Submit" })
            }
            name="submit"
            className="btn btn-primary w-100"
            disabled={state.buttonDisable}
          >
            {state.buttonDisable
              ? t({ id: "Submitting..." })
              : t({ id: "Submit" })}
          </button>
        </FormGroup>
      </Form>
    </div>
  )
}

LoginForm.propTypes = {
  setTokens: PropTypes.func,
  setUser: PropTypes.func,
  precache: PropTypes.func,
  trackActivity: PropTypes.func,
  setPage: PropTypes.func,
  logout: PropTypes.func,
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "20px",
}

const mapDispatchToProps = (dispatch, state) => {
  return {
    login: (username, password) => dispatch(loginAction(username, password)),
    trackActivity: (data) => dispatch(trackActivity(data)),
    logout: () => dispatch(logoutAction()),
    setPage: (page) => dispatch(setCurrentPage(page)),
    precache: () => dispatch(precacheData()),
    setUser: (data) => dispatch(triggerAction("SET_USER_DATA", data)),
    setTokens: (token, tokenBC) =>
      dispatch(triggerAction("SET_USER_DATA", { ...state.user, token, tokenBC })),
  }
}

const mapStateToProps = (state) => {
  return {
    isConnected: state.isConnected,
    user: state.user,
    error: state.vlsasLoadingError,
    members: state.loadedvslaMembers.filter(
      (member) => member?.status === "Active" && member?.blockchain_wallet_id !== null,
    ),
    vslaSummary: selectCreatedVslaInfo(state),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)
